import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { sortBySequence } from '@/helpers/commonFunctions';
import { cn } from '@/lib/utils';
import ChatEntry from '../livekit/chat/chat-entry';
const ChatEntryMotion = motion.create(ChatEntry);
export function Transcript({ ref, messages, className, agentState, audioTrack, }) {
    const transcriptRef = useRef(null);
    const handleRef = useCallback((node) => {
        transcriptRef.current = node;
        if (ref) {
            if (typeof ref === 'function') {
                ref(node);
            }
            else {
                ref.current = node;
            }
        }
    }, [ref]);
    // auto scroll transcript
    useEffect(() => {
        const scrollingElement = transcriptRef.current;
        if (!scrollingElement)
            return;
        // Observe the content container (the first child) for size changes.
        // We observe the child because the parent has a fixed max-height,
        // so its own size won't change when messages are added.
        const contentElement = scrollingElement.firstElementChild;
        if (!contentElement)
            return;
        const scrollToBottom = () => {
            scrollingElement.scrollTop = scrollingElement.scrollHeight;
        };
        const resizeObserver = new ResizeObserver(scrollToBottom);
        resizeObserver.observe(contentElement);
        // Initial scroll to bottom (important for cached messages)
        scrollToBottom();
        return () => resizeObserver.disconnect();
    }, [messages]);
    const sortedMessages = sortBySequence(messages);
    return (_jsx("div", { ref: handleRef, className: cn('scrollbar-on-hover flex max-h-[380px] grow flex-col overflow-x-hidden overflow-y-scroll py-3 pr-3 pl-1 md:ml-[200px]', '[mask-image:linear-gradient(0deg,rgba(0,0,0,0.2)_0%,rgba(0,0,0,1)_5%,rgba(0,0,0,1)_95%,rgba(0,0,0,0)_100%)]', className), children: _jsx("div", { className: "flex flex-col justify-end gap-2 pt-16", children: _jsx(AnimatePresence, { children: sortedMessages === null || sortedMessages === void 0 ? void 0 : sortedMessages.map((message) => (_jsx(ChatEntryMotion, { hideName: true, initial: { opacity: 0, height: 0 }, animate: { opacity: 1, height: 'auto' }, exit: { opacity: 1, height: 'auto', translateY: 0.001 }, transition: { duration: 0.5, ease: 'easeOut' }, entry: message, agentState: agentState, audioTrack: audioTrack }, message.id))) }) }) }));
}
